import { ErpTypeConfig } from './types';

export const ERP_TYPES: Record<string, ErpTypeConfig> = {
    salesforce: {
        label: 'Salesforce',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Salesforce.com_logo.svg/1280px-Salesforce.com_logo.svg.png',
    },
    // Add new ERP types here:
    // sap: {
    //     label: 'SAP',
    //     logo: 'https://example.com/sap-logo.png',
    // },
};

export const INITIAL_SALESFORCE_FORM = {
    name: '',
    sf_instance_url: '',
    sf_client_id: '',
    sf_username: '',
    sf_domain: 'login.salesforce.com',
    sf_private_key: '',
};
